import { Link } from "react-router-dom";
import "../blocks/Projects.css";
import lines from "../../src/images/projects_lines.png";
import leftPng from "../../src/images/projects_left.png";
import rightTopPng from "../../src/images/projects_right-top.png";
import rightMiddlePng from "../../src/images/projects_right-middle.png";
import leftMiddlePng from "../../src/images/projects_left-middle.png";
import bottomPng from "../../src/images/projects_bottom.png";
import mobileLines from "../../src/images/projects_mobile-lines.png";
import gifOne from "../../src/images/projectGifs/gif_one.png";
import gifTwo from "../../src/images/projectGifs/gif_two.gif";
import gifThree from "../../src/images/projectGifs/gif_three.gif";
import gifFour from "../../src/images/projectGifs/gif_four.png";
import gifFive from "../../src/images/projectGifs/gif_five.gif";
import gifSix from "../../src/images/projectGifs/gif_six.gif";
import gifSeven from "../../src/images/projectGifs/gif_seven.gif";
import gifEight from "../../src/images/projectGifs/gif_eight.gif";

function Projects() {
  return (
    <section className="projects">
      <div className="projects__cont">
        <div className="projects__title-cont">
          <h3 className="projects__title">интернет и тв</h3>
          <span className="projects__span">проекты</span>
          <span className="projects__years">{"(2021 ------> 2025)"}</span>
          <span className="projects__mobile-years">{"(2021 ---> 2025)"}</span>
        </div>
        <div className="projects__bottom-cont">
          <img
            className="projects__left-bottom-img"
            src={leftPng}
            draggable="false"
            alt="||||"
          />
          <Link
            className="projects__link"
            to="https://www.youtube.com/watch?v=zc-Ihvm2hVc&t=85s"
            target="_blank"
          >
            <p className="projects__link-text">сольный концерт </p>
            <span className="projects__link-span">Черный стендап</span>
          </Link>
          <div className="projects__list-cont">
            <p className="projects__list-item">Stand Up на ТНТ</p>
            <p className="projects__list-item">Разгоны</p>
            <p className="projects__list-item">Открытый микрофон на ТНТ</p>
            <p className="projects__list-item">Токсики</p>
            <p className="projects__list-item">Стендап на ходу</p>
            <p className="projects__list-item">Жгучий вопрос</p>
          </div>
        </div>
        <div className="projects__img-cont">
          <img
            className="projects__left-top-img"
            src={leftPng}
            draggable="false"
            alt="||||"
          />
          <img
            className="projects__right-top-img"
            src={rightTopPng}
            draggable="false"
            alt="|||"
          />
          <img
            className="projects__lines-img"
            src={lines}
            draggable="false"
            alt="||||"
          />
        </div>
        <div className="projects__mobile-img-cont">
          <img
            className="projects__left-middle-img"
            src={leftMiddlePng}
            draggable="false"
            alt="||||"
          />
          <img
            className="projects__right-middle-img"
            src={rightMiddlePng}
            draggable="false"
            alt="|||"
          />
          <img
            className="projects__bottom-img"
            src={bottomPng}
            draggable="false"
            alt="||||"
          />
          <img
            className="projects__mobile-lines-img"
            src={mobileLines}
            draggable="false"
            alt="||||"
          />
        </div>
      </div>
      <div className="projects__gif-cont">
        <img
          className="projects__lit-gif"
          src={gifOne}
          alt="img from concert"
        />
        <img className="projects__lit-gif" src={gifTwo} alt="animated GIF" />
        <img className="projects__lit-gif" src={gifThree} alt="animated GIF" />
        <img
          className="projects__lit-gif"
          src={gifFour}
          alt="img from concert"
        />
        <img className="projects__lit-gif" src={gifFive} alt="animated GIF" />
        <img className="projects__med-gif" src={gifSix} alt="animated GIF" />
        <img className="projects__med-gif" src={gifSeven} alt="animated GIF" />
        <img className="projects__big-gif" src={gifEight} alt="animated GIF" />
      </div>
      <div className="projects__mobile-gif-cont">
        <img
          className="projects__mobile-gif"
          src={gifEight}
          alt="animated GIF"
        />
        <div className="projects__gif-inner-cont">
          <img
            className="projects__mobile-inner-gif"
            src={gifOne}
            alt="img from concert"
          />
          <img
            className="projects__mobile-inner-gif"
            src={gifFive}
            alt="animated GIF"
          />
        </div>
        <div className="projects__gif-inner-cont">
          <img
            className="projects__mobile-inner-gif"
            src={gifFour}
            alt="img from concert"
          />
          <img
            className="projects__mobile-inner-gif"
            src={gifThree}
            alt="animated GIF"
          />
        </div>
        <img className="projects__mobile-gif" src={gifSix} alt="animated GIF" />
        <img
          className="projects__mobile-gif"
          src={gifSeven}
          alt="animated GIF"
        />
        <img className="projects__mobile-gif" src={gifTwo} alt="animated GIF" />
      </div>
    </section>
  );
}

export default Projects;
